import React, {useEffect} from 'react'
import {
    Button,
    Dialog,
    DialogActions,
    DialogTitle,
    DialogContent,
    DialogContentText
} from '@material-ui/core';
import AsyncAutoComplete from "../AsyncAutoComplete";

const AssignDialog = ({
                          fetch, open, body, label,
                          handleClose, handleSave, selected, setSelected,
                          multiple=false, submitText="Save", ...props
                      }) => {
    const handleChange = (selected) => {
        setSelected(selected);
    }

    useEffect(() => {
        setSelected(selected)
    }, [selected])

    return (
        <Dialog open={open} onClose={handleClose} aria-labelledby="form-dialog-title" fullWidth>
            <DialogTitle id="form-dialog-title">Update {label}</DialogTitle>
            <DialogContent>
                <DialogContentText>
                    {body}
                </DialogContentText>

                <AsyncAutoComplete
                    autoComplete
                    includeInputInList
                    value={selected}
                    fetch={fetch}
                    handleOnChange={handleChange}
                    label={label}
                    getOptionLabel={(option) => option.name}
                    getOptionSelected={(option, value) => option.id === value.id}
                    multiple={multiple}
                />
            </DialogContent>
            <DialogActions>
                <Button onClick={handleClose}>
                    Cancel
                </Button>
                <Button onClick={handleSave} color="primary">
                    {submitText}
                </Button>
            </DialogActions>
        </Dialog>
    )
}

export default AssignDialog;